if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.setAttribute('open', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('open');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      onDPO_SubmitHandler(_formData, _DPO_data, { variantId, quantity, button, evt, callback }) {
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.delete('properties[ACE Total]');

        _formData.map((item) => {
          formData.append(`properties[${item[0]}]`, item[1]);
        });

        if (_DPO_data) {
          if (_DPO_data.params) {
            _formData.push(['_products', JSON.stringify([_DPO_data.params])]);
          }

          if (_DPO_data.accessories) {
            _formData.push(['_accessories', JSON.stringify(_DPO_data.accessories)]);
          }

          if (_DPO_data.aceResult) {
            _formData.push(['_info', JSON.stringify(_DPO_data.aceResult)]);
          }

          formData.append('properties[_dpo_id]', _DPO_data._dpo_id);
          formData.append('properties[__dpo_hash]', _DPO_data._dpo_hash);

          if (_formData.length > 0) {
            formData.append('properties[__dpo_p]', JSON.stringify(Object.fromEntries(_formData)));
          }
        }

        if (variantId) {
          formData.delete('id');
          formData.append('id', variantId);
        }

        if (quantity) {
          formData.delete('quantity');
          formData.append('quantity', quantity);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        async function fetchJSON(url, config) {
          const response = await fetch(url, config);
          const data = await response.json().catch(() => ({}));
          if (!response.ok) throw { status: response.status, ...data };
          return data;
        }

        fetchJSON(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            this.showErrorPopup(e.description);
            console.error(e);
          })
          .finally(() => {
            window.removeEventListener('beforeunload', window.beforeUnloadHandler);

            if (button) {
              button.removeAttribute('open');
            }

            if (callback) {
              callback();
            }

            this.submitButton?.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');

            // CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      showErrorPopup(message) {
        let modalContainer = document.querySelector('modal-container');
        if (!modalContainer) {
          modalContainer = document.createElement('modal-container');
          modalContainer.className = 'tw:modal-container tw:group/modal';
          document.body.appendChild(modalContainer);
        }

        modalContainer.innerHTML = `
            <modal-content class="tw:modal-content" role="dialog" aria-modal="true" aria-label="Error" tabindex="-1">
              <div class="tw:py-6.25 tw:px-6.25 tw:flex tw:flex-col tw:justify-center tw:items-center tw:h-full tw:gap-3.75 tw:relative tw:overflow-hidden">
                <modal-close class="tw:absolute tw:top-2.5 tw:right-2.5 tw:p-[2.5px] tw:text-primary tw:cursor-pointer tw:z-[1]" aria-label="Close dialog">
                  <span class="tw:svg-icon tw:w-6.25 tw:h-6.25">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.02148 1.01953L24.9798 24.9779" stroke="currentColor" stroke-linecap="square"/>
                      <path d="M24.9798 1.01953L1.02148 24.9779" stroke="currentColor" stroke-linecap="square"/>
                    </svg>
                  </span>
                </modal-close>
                <div class="tw:flex tw:flex-col tw:gap-2.5 tw:w-full">
                  <h4 class="tw:text-xl tw:text-tertiary tw:font-bold">Error</h4>
                  <p class="tw:text-base tw:text-dark-600 tw:font-semibold">${message}</p>
                </div>
              </div>
            </modal-content>
            <modal-close data-action="close" class="tw:modal-bg-layer"></modal-close>
          `;
        modalContainer.setAttribute('open', '');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) {
          this.showErrorPopup(errorMessage);
        } else {
          this.errorMessage =
            this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          // if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          // this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
